import { OnboardingContext } from 'contexts/providers/OnboardingProvider'
import { useContext } from 'react'

export function useOnboarding() {
  return useContext(OnboardingContext)
}
